import { KeyValueModel } from "model";
import { EnumTpPessoaComissionamento } from "model/enums/enum-tp-pessoa-comissionamento";

export const tpComissionadoRotaMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpPessoaComissionamento.Gerente, 'gerente'),
    new KeyValueModel(EnumTpPessoaComissionamento.GerenteGeral, 'gerente-geral'),
    new KeyValueModel(EnumTpPessoaComissionamento.Vendedor, 'vendedor'),
]